import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const ArrangeSquareIcon = forwardRef<SVGSVGElement, IconProps>(function ArrangeSquareIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54437 1.54437C2.6616 0.427145 4.33342 0 6.48837 0H11.5116C13.6666 0 15.3384 0.427145 16.4556 1.54437C17.5729 2.6616 18 4.33342 18 6.48837V11.5116C18 13.6666 17.5729 15.3384 16.4556 16.4556C15.3384 17.5729 13.6666 18 11.5116 18H6.48837C4.33342 18 2.6616 17.5729 1.54437 16.4556C0.427145 15.3384 0 13.6666 0 11.5116V6.48837C0 4.33342 0.427145 2.6616 1.54437 1.54437ZM2.43237 2.43237C1.66588 3.19886 1.25581 4.45728 1.25581 6.48837V11.5116C1.25581 13.5427 1.66588 14.8011 2.43237 15.5676C3.19886 16.3341 4.45728 16.7442 6.48837 16.7442H11.5116C13.5427 16.7442 14.8011 16.3341 15.5676 15.5676C16.3341 14.8011 16.7442 13.5427 16.7442 11.5116V6.48837C16.7442 4.45728 16.3341 3.19886 15.5676 2.43237C14.8011 1.66588 13.5427 1.25581 11.5116 1.25581H6.48837C4.45728 1.25581 3.19886 1.66588 2.43237 2.43237ZM10.2834 4.10826C10.5181 4.01107 10.7881 4.06479 10.9677 4.24437L13.5128 6.78949C13.758 7.0347 13.758 7.43227 13.5128 7.67748C13.2676 7.9227 12.8701 7.9227 12.6248 7.67748L11.1516 6.20427V13.3116C11.1516 13.6584 10.8705 13.9395 10.5237 13.9395C10.1769 13.9395 9.89581 13.6584 9.89581 13.3116V4.68837C9.89581 4.43441 10.0488 4.20545 10.2834 4.10826ZM7.47628 4.06046C7.82306 4.06046 8.10419 4.34159 8.10419 4.68837V13.3116C8.10419 13.5656 7.9512 13.7946 7.71657 13.8917C7.48194 13.9889 7.21186 13.9352 7.03228 13.7556L4.48716 11.2105C4.24195 10.9653 4.24195 10.5677 4.48716 10.3225C4.73238 10.0773 5.12995 10.0773 5.37516 10.3225L6.84837 11.7957V4.68837C6.84837 4.34159 7.1295 4.06046 7.47628 4.06046Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
